import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChecklistLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Checklist / Light",
		clipPath: "url(#clip0_12889_47028)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 380",
				d: "M19 38.5C19.6667 41.1667 21.4 45.4 23 41C24.6 36.6 25 34.5 25 34",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 382",
				d: "M25 53.5C25.6667 56.1667 27.4 60.4 29 56C30.6 51.6 31 49.5 31 49",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 381",
				d: "M32 38L47.5 34.5",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 383",
				d: "M37 51.5L48.5 49",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 384",
				d: "M32 65.5001L41.5343 63.4275C42.3417 63.252 42.556 62.251 42.0959 61.5648C41.758 61.0609 41.9478 60.8349 43.5 61.5001C46.3 62.7001 47.6667 62.6668 48 62.5001",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Subtract",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.51354 30.9663C11.6968 44.0877 21.0599 65.4633 27.8249 74.8964C16.5424 64.3722 -3.81841 32.3116 0.623504 31.9102L7.51354 30.9663Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 388",
				d: "M88.4999 49.0001L55.2921 59.6375",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Subtract_2",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M60.9455 55.7263C60.483 54.6067 60.0197 53.449 59.5573 52.2563C55.4614 41.6893 51.4474 28.387 48.6769 14.3572C48.5204 13.5645 47.7637 13.0318 46.9616 13.1621L7.9362 19.5037C7.65484 19.5329 7.41805 19.6681 7.24402 19.879C7.07715 20.0811 6.98132 20.3352 6.92475 20.5945C6.81221 21.1103 6.82316 21.8011 6.91521 22.6052C7.10098 24.2279 7.64128 26.4976 8.44112 29.1862C10.0436 34.5729 12.7169 41.7355 15.8026 48.971C18.8885 56.2069 22.3939 63.5321 25.6646 69.2422C27.2993 72.096 28.8821 74.5581 30.3305 76.4067C31.0548 77.331 31.7522 78.1107 32.4125 78.7115C33.0679 79.3079 33.7126 79.7522 34.3337 79.9714C36.5635 80.7584 40.0605 80.8741 43.9551 80.616C47.8724 80.3564 52.2688 79.7122 56.3445 78.9284C60.4199 78.1447 64.1887 77.2187 66.8515 76.3914C68.1782 75.9793 69.2516 75.5852 69.9539 75.2382C70.2952 75.0696 70.5973 74.8891 70.791 74.6942C70.8858 74.5988 71.0048 74.4508 71.0436 74.2518C71.0904 74.0119 71.0032 73.796 70.8536 73.6463C69.3517 72.1445 67.5541 69.4562 65.6101 65.7897C64.6104 63.9043 63.5767 61.7695 62.5291 59.4192L61.5711 59.7261C62.6422 62.1343 63.7009 64.3237 64.7266 66.2582C66.5896 69.7718 68.36 72.4759 69.9158 74.1164C69.8203 74.1786 69.6878 74.2543 69.5109 74.3417C68.8812 74.6528 67.8687 75.0283 66.5548 75.4365C63.9364 76.2499 60.2053 77.1676 56.1557 77.9464C52.1064 78.7251 47.7529 79.3621 43.889 79.6182C40.0023 79.8757 36.6868 79.7414 34.6665 79.0284C34.2251 78.8726 33.6956 78.5271 33.0855 77.9719C32.4803 77.4211 31.821 76.6875 31.1177 75.7899C29.7111 73.9948 28.1555 71.5788 26.5324 68.7451C23.2874 63.0801 19.7991 55.7929 16.7225 48.5787C13.6457 41.3643 10.9877 34.2393 9.3996 28.9011C8.60414 26.2272 8.08428 24.025 7.90872 22.4915C7.8201 21.7174 7.8251 21.159 7.90177 20.8076C7.9398 20.6333 7.98737 20.5493 8.01524 20.5155C8.02921 20.4986 8.03212 20.4985 8.03837 20.4983L8.04157 20.4982L8.061 20.4965L8.08025 20.4934L47.122 14.1491C47.3875 14.106 47.6429 14.2827 47.6959 14.551C50.4778 28.6389 54.5083 41.9973 58.6249 52.6177C59.0793 53.7899 59.5348 54.929 59.99 56.0324L60.9455 55.7263ZM70.0969 73.9722C70.097 73.9722 70.0962 73.9734 70.0941 73.9759C70.0958 73.9734 70.0968 73.9722 70.0969 73.9722Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 390 (Stroke)",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M53.7929 59.9438C53.9479 60.4739 53.6439 61.0293 53.1138 61.1843L52.0407 61.4982C52.0407 61.4982 50.4153 61.6755 50.2603 61.1454C50.1052 60.6154 51.4793 59.5786 51.4793 59.5786L52.5524 59.2647C53.0824 59.1097 53.6378 59.4137 53.7929 59.9438Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 389",
				d: "M91.2045 48.3044C92.4999 53 88.452 50.9918 85.9998 52.5688",
				stroke: "black",
				strokeWidth: 2,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Union",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M75.477 50.0033C76.1655 50.1876 76.8315 50.3971 77.4755 50.6299L75.8317 51.1422C75.6294 51.0822 75.425 51.0246 75.2185 50.9693C71.6367 50.0108 67.5999 50.4624 64.9568 51.2663C64.2996 51.4661 63.7389 51.6848 63.3001 51.9029C62.8514 52.1259 62.5668 52.3305 62.426 52.4872C62.4067 52.5087 62.3922 52.527 62.3814 52.5421C62.3995 52.554 62.4239 52.5684 62.4561 52.5844C62.5598 52.6359 62.7176 52.6911 62.9445 52.7404C63.8617 52.9396 64.9771 53.0552 66.215 53.1835L66.4458 53.2074C67.0965 53.2751 67.7749 53.3475 68.462 53.4388L66.0949 54.1764L66.0904 54.176C64.8747 54.0501 63.706 53.9291 62.7322 53.7176C62.4555 53.6575 62.2126 53.58 62.0112 53.48C61.8132 53.3816 61.624 53.2458 61.4975 53.0523C61.3607 52.8432 61.3221 52.6035 61.3762 52.3689C61.4262 52.1522 61.5481 51.9681 61.6821 51.8189C61.948 51.523 62.3651 51.2509 62.855 51.0074C63.3548 50.759 63.9694 50.5213 64.6659 50.3095C67.4377 49.4665 71.6703 48.9846 75.477 50.0033ZM77.4011 58.3106C76.8314 57.1338 76.0155 56.2483 75.0545 55.5741L73.7961 55.9663C74.9496 56.6058 75.8938 57.4921 76.501 58.7464C76.6263 59.0052 76.6386 59.1528 76.6298 59.2208C76.6243 59.2629 76.6109 59.2959 76.5442 59.3394C76.4591 59.3948 76.3007 59.4531 76.0384 59.4849C75.7821 59.516 75.4614 59.5178 75.0813 59.4891C73.5476 59.3731 71.2957 58.7816 69.0797 58.0459C67.9504 57.6709 66.843 58.0997 66.1835 58.852C65.5187 59.6102 65.2662 60.7535 65.9293 61.7834C69.988 68.0877 75.6872 75.0261 80.0975 78.5201C82.9275 80.762 85.7255 82.1762 88.1014 82.225C89.3074 82.2498 90.4116 81.9222 91.3338 81.1692C92.2499 80.4214 92.9463 79.2869 93.4063 77.7661C93.8756 76.2145 93.9563 73.9688 93.593 71.4361C93.2282 68.8932 92.4105 66.0214 91.046 63.2041C90.7527 62.5984 90.4338 61.9948 90.0885 61.3973C89.8258 60.9067 89.5457 60.4191 89.2479 59.9365L89.1853 59.9418C87.5131 57.429 85.339 55.0873 82.5882 53.2264L81.3475 53.613C84.8195 55.7788 87.3925 58.7346 89.2135 61.8815C89.3869 62.2057 89.5526 62.5314 89.7108 62.8579C91.0288 65.5794 91.8172 68.3517 92.1679 70.796C92.5199 73.2504 92.4251 75.3349 92.0139 76.6945C91.5933 78.0847 90.9859 79.0249 90.2662 79.6125C89.5526 80.1951 88.6891 80.4637 87.6867 80.4431C85.646 80.4012 83.0647 79.1576 80.2832 76.9541C76.086 73.629 70.6041 67.0095 66.5941 60.8601C66.4551 60.3817 66.6005 59.8932 66.9354 59.5113C67.3657 59.0205 68.0659 58.7629 68.7646 58.9949C70.9927 59.7347 73.3426 60.3605 75.0059 60.4863C75.4252 60.518 75.8159 60.5192 76.1589 60.4776C76.4959 60.4368 76.8246 60.3502 77.0899 60.1773C77.3736 59.9926 77.5741 59.7139 77.6214 59.3498C77.6654 59.0116 77.5695 58.6584 77.4011 58.3106Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group 100",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group 98",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Vector 140",
						d: "M20.9455 25.7497C21.51 24.5436 23.113 22.1771 25.0096 22.3601C27.3803 22.5888 16.8814 29.1394 20.9455 27.9932C25.0096 26.847 29.0737 21.9617 30.767 21.9328C32.4604 21.9039 25.0096 28.6418 31.1057 24.2303C35.9826 20.7012 39.0081 18.9106 39.9112 18.4565",
						stroke: "#4F49BA",
						strokeLinecap: "round"
					})
				})
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_12889_47028",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 96,
			height: 96,
			fill: "white"
		})
	}) })]
});
export default SvgChecklistLight;
